import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { init } from '@plausible-analytics/tracker';
import "./custom.scss";

// Initialiser Plausible Analytics uniquement en production
if (process.env.REACT_APP_ENV === 'PRD') {
  init({
    domain: 'ship.mobiuspack.com'
  });
}

// Initialiser Hotjar (Application consommateur) uniquement en production
if (process.env.REACT_APP_ENV === 'PRD') {
  (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:6785387,hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
  })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

